<app-simple-dialog 
  [title]="'exit-signing.modal.title' | translate" 
  [analyticsPrefix]="'exit-signing-modal'"
  #exitDialog
>
  <div class="modal-body">
    <p class="modal-message">{{ 'exit-signing.modal.message' | translate }}</p>
  </div>
  
  <div class="modal-footer">
    <button
      novaButton
      variant="secondary"
      (click)="close()"
      class="cancel-button"
    >
      {{ 'exit-signing.modal.cancel' | translate }}
    </button>
    <button
      novaButton
      variant="primary"
      (click)="confirmExit()"
      class="confirm-button"
    >
      {{ 'exit-signing.modal.confirm' | translate }}
    </button>
  </div>
</app-simple-dialog>